import { render, staticRenderFns } from "./coll-export-config.vue?vue&type=template&id=6bb4d23a"
import script from "./coll-export-config.vue?vue&type=script&lang=ts"
export * from "./coll-export-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports